import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getRouteStatusSections, getRouteStatusLoading } from '../store/apply/selectors';

export function useTaskRouteGuard(taskRoute: string) {
  const navigate = useNavigate();
  const { uni, userId, applicationId } = useParams<{
    uni: string;
    userId: string;
    applicationId: string;
  }>();

  const sections = useSelector(getRouteStatusSections);
  const isLoading = useSelector(getRouteStatusLoading);

  useEffect(() => {
    // Don't check while loading or if sections haven't loaded yet
    if (isLoading || !sections) return;

    // Check if the task exists in any section's task groups
    const isTaskVisible = sections.some(section =>
      section.taskGroups?.some(group => group.tasks.some(task => task.route.includes(taskRoute))),
    );

    // If task is not visible, redirect to sections page
    if (!isTaskVisible) {
      navigate(`/application/${uni}/${userId}/${applicationId}/sections`, { replace: true });
    }
  }, [sections, isLoading, taskRoute, navigate, uni, userId, applicationId]);

  // Return loading state and whether the task is allowed
  const isAllowed =
    isLoading ||
    !sections ||
    sections.some(section =>
      section.taskGroups?.some(group => group.tasks.some(task => task.route.includes(taskRoute))),
    );

  return { isLoading, isAllowed };
}
